/* Uses the native product offer; never sends a competing cart request. */
(function () {
  'use strict';
  if (window.boutiqueCroLoaded) return;
  window.boutiqueCroLoaded = true;
  var cleanup = function () {};
  var cleanupCart = function () {};
  function bootCart() {
    cleanupCart();
    var form = document.getElementById('CartPageForm');
    var checkout = form && form.querySelector('[data-boutique-cart-checkout]');
    if (!checkout) return;
    var wrapper = form.parentNode;
    function measure() {
      var active = !wrapper.classList.contains('is-empty');
      document.body.classList.toggle('boutique-cart-has-checkout', active);
      document.documentElement.style.setProperty('--boutique-cart-bar-height', Math.ceil(checkout.getBoundingClientRect().height) + 'px');
      var header = document.querySelector('#SiteHeader');
      if (header) document.documentElement.style.setProperty('--boutique-cart-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    }
    var resize = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    if (resize) resize.observe(checkout);
    var mutation = new MutationObserver(measure);
    mutation.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', measure);
    measure();
    cleanupCart = function () {
      if (resize) resize.disconnect();
      mutation.disconnect();
      window.removeEventListener('resize', measure);
      document.body.classList.remove('boutique-cart-has-checkout');
      document.documentElement.style.removeProperty('--boutique-cart-bar-height');
      document.documentElement.style.removeProperty('--boutique-cart-header-height');
    };
  }
  function boot() {
    cleanup();
    var root = document.querySelector('.boutique-product[data-history="true"]');
    var bar = document.querySelector('[data-boutique-sticky]');
    if (!root || !bar) return;
    var button = root.querySelector('[data-add-to-cart]');
    if (!button) return;
    var listeners = [], observer;
    function listen(el, type, handler) { if (!el) return; el.addEventListener(type, handler); listeners.push(function () { el.removeEventListener(type, handler); }); }
    function chosen() {
      var json = root.querySelector('[data-variant-json]');
      var select = root.querySelector('[data-product-select]');
      try {
        var variants = JSON.parse(json.value || json.textContent);
        var groups = Array.from(root.querySelectorAll('.boutique-options .variant-input-wrap[data-index]'));
        if (groups.length) return variants.find(function (v) { return groups.every(function (group) {
          var selected = group.querySelector('input:checked, select[data-variant-input]');
          return selected && v[group.dataset.index] === selected.value;
        }); });
        return variants.find(function (v) { return String(v.id) === select.value; });
      } catch (_) { return null; }
    }
    function sync() {
      var v = chosen();
      var price = bar.querySelector('[data-boutique-sticky-price]');
      if (!v) { price.textContent = ''; bar.querySelector('[data-boutique-sticky-options]').textContent = 'Choisissez une combinaison disponible'; return; }
      // formatMoney can contain HTML (currency markup). Reuse native price safely as text.
      var nativePrice = root.querySelector('[data-product-price]');
      price.textContent = nativePrice ? nativePrice.textContent : '';
      bar.querySelector('[data-boutique-sticky-options]').textContent = v.title === 'Default Title' ? 'Livraison offerte' : v.title;
    }
    function visibility() {
      var rect = button.getBoundingClientRect();
      // Show only after the customer has passed the actual purchase action.
      var show = rect.bottom < 0 && !document.querySelector('dialog[open], .modal--is-active, .drawer--is-open');
      bar.hidden = !show;
      if (document.body.classList.contains('boutique-has-sticky') !== show) document.body.classList.toggle('boutique-has-sticky', show);
    }
    listen(window, 'scroll', visibility);
    listen(window, 'resize', visibility);
    listen(root, 'variantChange', function () { requestAnimationFrame(sync); });
    listen(root, 'change', function () { requestAnimationFrame(sync); });
    listen(bar.querySelector('[data-boutique-buy-scroll]'), 'click', function () {
      var target = root.querySelector('.boutique-options') || button;
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      var focus = target.querySelector('input:checked, select') || button;
      focus.focus({ preventScroll: true });
    });
    var dialog = document.querySelector('[data-boutique-size-dialog]');
    var source = Array.from(document.querySelectorAll('.boutique-product[data-history="true"] .rte table, [data-boutique-description] .rte table')).find(function (table) { return /taille|size|poitrine/i.test(table.textContent); });
    var sizeButtons = document.querySelectorAll('[data-boutique-size-open]');
    if (source && dialog && typeof dialog.showModal === 'function') {
      var copy = source.cloneNode(true);
      copy.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      var content = dialog.querySelector('[data-boutique-size-content]');
      content.replaceChildren(copy);
      // Include existing adjacent sizing instructions, without creating another chart.
      var before = source.previousElementSibling;
      if (before && before.tagName === 'P' && /hésit|bonnet|mesur|taille|poitrine/i.test(before.textContent)) content.insertBefore(before.cloneNode(true), copy);
      var next = source.nextElementSibling;
      if (next && /hésit|bonnet|mesur|taille/i.test(next.textContent)) content.appendChild(next.cloneNode(true));
      sizeButtons.forEach(function (btn) {
        btn.hidden = false;
        listen(btn, 'click', function () { dialog.showModal(); visibility(); });
      });
      listen(dialog.querySelector('[data-boutique-size-close]'), 'click', function () { dialog.close(); });
      listen(dialog, 'close', visibility);
      listen(dialog, 'click', function (event) {
        if (event.target !== dialog) return;
        var r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
    }
    observer = new MutationObserver(visibility);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    sync(); visibility();
    cleanup = function () { listeners.forEach(function (f) { f(); }); observer.disconnect(); bar.hidden = true; document.body.classList.remove('boutique-has-sticky'); if (dialog && dialog.open) dialog.close(); };
  }
  // Repair existing lower-page CTA whose link was just '#'.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href="#"]');
    if (!link || !/ajouter au panier/i.test(link.textContent)) return;
    var root = document.querySelector('.product-section[data-history="true"]');
    if (!root) return;
    event.preventDefault();
    var target = root.querySelector('.boutique-options, .zip2__variants') || root.querySelector('[data-add-to-cart]');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  function bootAll() { boot(); bootCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
  document.addEventListener('shopify:section:unload', function () { cleanup(); cleanupCart(); });
})();
